import React, { useState } from 'react';
import { TextField, InputAdornment, IconButton } from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';

/** TextField de senha com botão para mostrar/ocultar. Repassa as demais props. */
const PasswordField = ({ disabled, ...textFieldProps }) => {
    const [isVisible, setIsVisible] = useState(false);

    return (
        <TextField
            {...textFieldProps}
            disabled={disabled}
            type={isVisible ? 'text' : 'password'}
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            aria-label={isVisible ? 'Ocultar senha' : 'Mostrar senha'}
                            onClick={() => setIsVisible(!isVisible)}
                            disabled={disabled}
                            edge="end"
                        >
                            {isVisible ? <VisibilityOffIcon /> : <VisibilityIcon />}
                        </IconButton>
                    </InputAdornment>
                )
            }}
        />
    );
};

export default PasswordField;
